module.exports = __webpack_public_path__ + "static/media/084.4801b4e1.jpg";